











































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
@Component({
  components: {},
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.TelegramGroupServiceProxy();
  }
  input: proxy.TelegramGroupPageInputDto =
    new proxy.TelegramGroupPageInputDto();
  sub_id = 0;
  isEnableBots = 0;
  createOrEditShow = false;
  createrange = [];
  BalanceTypes = [];
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },

    {
      title: "群组类型",
      slot: "telegramGroupTypeName",
    },
    {
      title: "群名称",
      key: "name",
    },
    {
      title: "群ID",
      key: "chatId",
    },
    {
      title: "状态",
      slot: "isEnableBot",
    },
    {
      title: "绑定对象",
      slot: "bind",
    },
    {
        title:'USDT地址',
        key:'usdtSendAddress'
    }
  ];

  telegramGroupTypechange(row) {
    this.prox.update(row).then((x) => {
      this.$Notice.success({ title: "修改成功" });
    });
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.isEnableBot = this.isEnableBots == 0 ? true :false;
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    // this.prox.export(this.input).then((x) => {
    //   location.href =
    //     AppConsts.remoteServiceBaseUrl +
    //     '/File/DownloadTempFile?FileToken=' +
    //     x.fileToken +
    //     '&fileName=' +
    //     x.fileName +
    //     '&fileType=' +
    //     x.fileType;
    // });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    new proxy.CommonServiceProxy()
      .getEnumKeyValue("BalanceTypeEnum")
      .then((x) => {
        this.BalanceTypes = x;
      });
    this.getpage();
  }
}
